var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-pagination',{staticStyle:{"padding-top":"20px","text-align":"right"},attrs:{"background":"","layout":"prev, pager, next","page-size":_vm.listPagin.limit,"total":_vm.listPagin.total},on:{"current-change":_vm.changePage}})
}
var staticRenderFns = []

export { render, staticRenderFns }